export const APP_NAME: string = import.meta.env.VITE_APP_NAME ?? "DIVEROID";
export const SUPPORT_EMAIL: string =
  import.meta.env.VITE_SUPPORT_EMAIL ?? "support@diveroid.com";

/**
 * Public base URL where this web app is deployed (e.g. the confirm domain).
 * Used to build absolute links such as the post-deletion "open app" CTA.
 * Configure per environment via `VITE_APP_URL`; trailing slashes are stripped.
 */
export const APP_URL: string = (
  import.meta.env.VITE_APP_URL ?? "https://confirm.diveroid.shop"
).replace(/\/+$/, "");

/**
 * Length of the e-mail OTP that GoTrue issues for `signInWithOtp` /
 * `verifyOtp({ type: "email" })`. This is fixed in Supabase right now
 * (6 digits) but we keep it as a constant so UI can reference it.
 */
export const OTP_LENGTH: number = 6;

/** Minimum password length enforced for setup / reset flows. */
export const PASSWORD_MIN_LENGTH: number = 6;

/** Cooldown (seconds) before the user may request another OTP. */
export const OTP_RESEND_COOLDOWN_SECONDS: number = 60;
